module.exports = __webpack_public_path__ + "static/media/background.b75a3897.jpeg";